import React from "react";
import AssetTypes from "../../../enums/assetTypes";
import { type CardBase } from "../../../interfaces/CardPropsBase";
import dateTimeUtils from "../../../utils/dateTimeUtils";
import CardContent from "../cardContent/CardContent";
import CardThumbnail from "../cardThumbnail/CardThumbnail";
import SelectableCard from "../selectableCard/SelectableCard";
import { type CardVideoItem } from "./types";

export interface VideoCardLayoutProps extends CardBase<CardVideoItem> {
  visibility?: boolean;
}

export function VideoCardLayout(props: React.PropsWithChildren<VideoCardLayoutProps>) {
  const { url, selected, onSelect, onTitleClick, children, className, disabled, icons, item, selectable, visibility } =
    props;

  const { thumbnailUrl, title, publisher, id, duration } = item;

  return (
    <SelectableCard
      url={url}
      className={className}
      id={id}
      onCardClick={url ? null : onTitleClick}
      selected={selected}
      onSelect={onSelect}
      disabled={disabled}
    >
      <CardThumbnail
        draggable={false}
        thumbnailUrl={thumbnailUrl}
        selected={selected}
        selectable={selectable}
        disabled={disabled}
        isHidden={visibility}
      >
        <span className="type">{AssetTypes.Video}</span>
        {<span className="duration">{dateTimeUtils.durationSecondsToTime(duration)}</span>}
      </CardThumbnail>
      <CardContent title={title} meta={publisher} icons={icons}>
        {children}
      </CardContent>
    </SelectableCard>
  );
}
